module.exports = __webpack_public_path__ + "static/media/referensiel-book.abb9d475.png";